
import { mapGetters } from 'vuex'
import InnerLoading from '../Shared/Loading/InnerLoading.vue'
import Purchase from './Purchase.js'
import Transfer from './Transfer'
import Packages from './Packages.vue'
export default {
  components: { InnerLoading, Transfer, Packages },
  mixins: [Purchase],
  data() {
    return {
      pageLoaded: {
        isLoading: true,
      },
    }
  },
  computed: {
    ...mapGetters({
      getValidPayments: 'seances/getValidPayments',
      getCustomerPackages: 'seances/getCustomerPackages',
    }),
    getPurchasedPackages() {
      if (this.item.Processes === 0) return []
      return (
        this.getCustomerPackages.filter(
          (c) =>
            c.isPurchased &&
            c.ProcessesData.find((p) => p.Id === this.item.Processes[0].Id) &&
            c.remainCount > 0
        ) || []
      )
    },
  },
  async mounted() {
    if (this.item.Price === 0) this.SEND_REZ(false)
    else
      this.pageLoaded = await this.$store.dispatch('seances/GET_VALID_PAYMENTS')
  },
}
